import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-736208c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "module introduce fade-in fade-in-moveUp" }
const _hoisted_2 = { class: "module-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "module-title" }, "核心能力介绍", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "module-subTitle" }, " 爱乐云专注于解决婚恋行业痛点，为您提供行业内最全面、最专业的系统化技术服务 ", -1))
const _hoisted_5 = { class: "introduce-tabs" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "swiper-container" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "module advantage fade-in fade-in-moveUp" }
const _hoisted_10 = { class: "module-content" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "module-title" }, "我们的特点", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "module-subTitle" }, " 行业沉淀十余年，爱乐云已打磨出更优质、更稳定的一体化解决方案 ", -1))
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "module successCase fade-in fade-in-moveUp" }
const _hoisted_15 = { class: "module-content" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "module-title" }, "成功案例", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "module-subTitle" }, " 服务至今，爱乐云已成功帮助全国多个婚恋品牌实现转型及盈利 ", -1))
const _hoisted_18 = ["src"]

export function render(_ctx: any,_cache: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.introduceTabs, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["introduceTabs-item", {
                        'introduceTabs-activate':
                            _ctx.activateIntroduce === item.value,
                    }]),
              key: item.value,
              onClick: ($event: any) => (_ctx.onIntroduceTabs(item.value))
            }, _toDisplayString(item.name), 11, _hoisted_6))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.introduceTabs, (tab) => {
            return (_openBlock(), _createElementBlock("div", {
              key: tab.value,
              class: _normalizeClass(["swiper-item", {
                        'swiper-item-activate': _ctx.activateIntroduce === tab.value,
                    }])
            }, [
              _createVNode(_component_swiper, {
                loop: true,
                modules: _ctx.swiperModules,
                navigation: {
                            nextEl: `.swiper-button-next` + tab.value,
                            prevEl: `.swiper-button-prev` + tab.value,
                        },
                pagination: {
                            el: '.swiper-pagination' + tab.value,
                            clickable: true,
                        },
                autoplay: true,
                "slides-per-view": 1,
                class: "swiperBox",
                onSwiper: ($event: any) => (_ctx.onSwiper($event, tab.value)),
                onSlideChangeTransitionEnd: ($event: any) => (
                            _ctx.onSlideChangeTransitionEnd($event, tab.value)
                        )
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (_, index) => {
                    return _createVNode(_component_swiper_slide, { key: index }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          class: "swiperBox-img",
                          src: 
                                    require(`@/assets/images/introduce/${
                                        tab.url + (index + 1)
                                    }.jpg`)
                                
                        }, null, 8, _hoisted_8)
                      ]),
                      _: 2
                    }, 1024)
                  }), 64))
                ]),
                _: 2
              }, 1032, ["modules", "navigation", "pagination", "onSwiper", "onSlideChangeTransitionEnd"]),
              _createElementVNode("div", {
                class: _normalizeClass(["swiper-pagination", 'swiper-pagination' + tab.value])
              }, null, 2),
              _createElementVNode("div", {
                class: _normalizeClass(["swiper-button-prev", 'swiper-button-prev' + tab.value])
              }, null, 2),
              _createElementVNode("div", {
                class: _normalizeClass(["swiper-button-next", 'swiper-button-next' + tab.value])
              }, null, 2)
            ], 2))
          }), 128))
        ]),
        _createElementVNode("div", {
          class: "consultMore",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showPopup && _ctx.showPopup(...args)))
        }, "咨询更多")
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _hoisted_12,
        _createElementVNode("img", {
          class: "advantage-img",
          src: require('@/assets/images/advantage.jpg')
        }, null, 8, _hoisted_13)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _hoisted_17,
        _createElementVNode("img", {
          class: "successCase-img",
          src: require('@/assets/images/successCase.png')
        }, null, 8, _hoisted_18)
      ])
    ])
  ], 64))
}